"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var colorPalette_1 = require("../utils/colorPalette");
var SensorInfoBox = function (_a) {
    var value = _a.value, unit = _a.unit, footer = _a.footer, onClick = _a.onClick, className = _a.className, color = _a.color;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("ui-theme ui-sensor-info-box", className) },
        color && (react_1.default.createElement("div", { className: "ui-sensor-info-box-color-bar", style: { backgroundColor: (0, colorPalette_1.getColorCssValue)(color) } })),
        react_1.default.createElement("div", { className: "ui-sensor-info-box-content" },
            react_1.default.createElement("div", { className: "ui-sensor-info-box-value", onClick: onClick }, value),
            unit && react_1.default.createElement("span", { className: "ui-sensor-info-box-unit" }, unit)),
        footer && react_1.default.createElement("div", { className: "ui-sensor-info-box-footer" }, footer)));
};
exports.default = SensorInfoBox;
